import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchLogsTracker } from "./loginAPI";

export interface LogsState {
  logsTracker: any;
  status: "idle" | "loading" | "failed" | "success";
}

const initialState: LogsState = {
  logsTracker: {},
  status: "idle",
};

export const GetLogsTracker = createAsyncThunk("user/LogsTracker", async (data:any) => {
  const response = await fetchLogsTracker(data);
  return response;
});
export const LogsTrackerSlice = createSlice({
  name: "LogsTracker",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetLogsTracker.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetLogsTracker.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(GetLogsTracker.fulfilled, (state, action) => {
        state.status = "success";
        
        state.logsTracker = action.payload;
       
      });
  },
});

export const {} = LogsTrackerSlice.actions;

export const selectLogsTracker = (state: RootState) => {
  return state.LogsTracker.logsTracker;
};

export default LogsTrackerSlice.reducer;
